export default function (theme) {
    return {
        MuiSelect: {
            selectMenu: {
                whiteSpace: 'normal',
                overflow: 'auto'
            },
        }
    };
}